module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bnWV7"))).then(() => parcelRequire('hEqeo'));